import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '../../atoms';
import { Caption, StyledQuestion } from './styles';

export const Question = ({ children, caption, prompt, as }) => (
  <StyledQuestion as={as}>
    <Heading
      headingLevel="h3"
      headingText={prompt}
      position="center"
      typography="heading3"
    />
    {children}
    {caption && <Caption>{caption}</Caption>}
  </StyledQuestion>
);

Question.displayName = 'Question';
Question.propTypes = {
  children: PropTypes.node,
  prompt: PropTypes.string.isRequired,
  caption: PropTypes.string,
  as: PropTypes.string,
};
